import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * The fixed-size frame every stage of the hero's loop renders into.
 *
 * The frame is a fixed height on purpose: the card must not resize while
 * the loop cycles, or the headline above it would shift five times every
 * twenty seconds. A stage that overflows this box is a layout bug.
 */
export function StageCard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "h-full overflow-hidden rounded-xl border border-white/10 bg-white/[0.03] p-4",
        className,
      )}
    >
      {children}
    </div>
  );
}
